/**
 * Anzeige von Zahlen und Beträgen.
 *
 * Beträge kommen als Zeichenkette vom Server (NUMERIC in der Datenbank) und
 * werden hier ausschließlich zur Anzeige umgewandelt. Gerechnet wird damit
 * nie - Abrechnung passiert serverseitig (09_billing_payments.md).
 */

/** Formatiert einen Betrag in Euro, etwa "184,50 €". */
export function formatMoney(amount: string, decimals = 2): string {
  const zahl = Number(amount);
  if (!Number.isFinite(zahl)) {
    return amount;
  }
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(zahl);
}

/** Formatiert ein Datum in der Schreibweise des Browsers. */
export function formatDate(value: string): string {
  const datum = new Date(value);
  return Number.isNaN(datum.getTime()) ? value : datum.toLocaleDateString();
}

/** Formatiert Datum und Uhrzeit, etwa "08.10.2026, 14:23". */
export function formatDateTime(value: string): string {
  const datum = new Date(value);
  if (Number.isNaN(datum.getTime())) {
    return value;
  }
  return datum.toLocaleString(undefined, {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

/**
 * Betrag mit Vorzeichen, etwa "+10,00 €" oder "-35,00 €".
 *
 * Das Vorzeichen steht in der Historie bewusst mit davor: eine Gutschrift und
 * eine Abbuchung sollen sich auf den ersten Blick unterscheiden.
 */
export function formatSignedMoney(amount: string): string {
  const zahl = Number(amount);
  if (!Number.isFinite(zahl)) {
    return amount;
  }
  return (zahl > 0 ? '+' : '') + formatMoney(amount);
}
